import React from 'react';
import Input from '@material-ui/core/Input';
import { Link, NavLink } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import DateFnsUtils from '@date-io/date-fns'; // choose your lib
// import {
//     DatePicker,
//     TimePicker,
//     DateTimePicker,
//     MuiPickersUtilsProvider,
// } from '@material-ui/pickers';
// import MomentUtils from '@date-io/moment';

// import DateFnsUtils from '@date-io/date-fns';

import DateFnsUtils from '@date-io/date-fns';
import ruLocale from "date-fns/locale/ru";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';

import { Button, CircularProgress, MenuItem, Select } from '@material-ui/core';

import PhoneInput from 'react-phone-input-2';

import { FormValidate, InputContainer, Label, SuccessMessage, ErrorMessage, LoadingContainer, PersDataContainer, LinksRow } from './Auth.style';
import AuthHeader from './AuthHeader';
import { TextMaskCustomDate, TextMaskCustomPhone, TextMaskCustomSnils } from './TextMasks';
import MainAuthComponent from './MainAuthComponent';

const Register = ({
    isLoading,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    middleName,
    setMiddleName,
    phone,
    setPhone,
    dateBirthday,
    setDateBirthday,
    snils,
    setSnils,
    email,
    setEmail,
    sex,
    onChangeSex,
    isError,
    onHandleRegister,
    successMessage,
    errorMessage,
}) => {
    return (
        <MainAuthComponent>
            <>
                <AuthHeader />
                <Label>РЕГИСТРАЦИЯ</Label>
                <FormValidate noValidate autoComplete="off">
                    <Grid container spacing={2} justify="center">
                        <Grid container item xs={12} sm={6} direction="column">
                            <InputContainer>
                                <Input
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    autoFocus
                                    fullWidth
                                    variant="filled"
                                    required
                                    id="lastname"
                                    placeholder="Фамилия *"
                                    error={isError && !lastName ? true : false}
                                />
                            </InputContainer>
                            <InputContainer>
                                <Input
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    required
                                    id="firstname"
                                    placeholder="Имя *"
                                    error={isError && !firstName ? true : false}
                                />
                            </InputContainer>
                            <InputContainer>
                                <Input
                                    value={middleName}
                                    onChange={(e) => setMiddleName(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    id="middlename"
                                    placeholder="Отчество"
                                    error={isError && !middleName ? true : false}
                                />
                            </InputContainer>
                            <InputContainer>
                                <Input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    required
                                    id="email"
                                    placeholder="e-mail"
                                    type="email"
                                    error={isError && isError === 'email' ? true : false}
                                />
                            </InputContainer>
                        </Grid>
                        <Grid container item xs={12} sm={6} direction="column">
                            <InputContainer style={{ display: 'flex' }}>
                                <Select
                                    value={sex}
                                    onChange={(e) => onChangeSex(e.target.value)}
                                    placeholder="Пол *"
                                    fullWidth
                                    variant="filled"
                                    id="sex"
                                    style={{
                                        textAlign: 'left'
                                    }}
                                    error={isError && sex === 0 ? true : false}
                                >
                                    <MenuItem value={1}>Женский</MenuItem>
                                    <MenuItem value={2}>Мужской</MenuItem>
                                    <MenuItem value={0}>Пол *</MenuItem>
                                </Select>
                            </InputContainer>
                            <InputContainer>
                                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                                    <KeyboardDatePicker
                                        variant="filled"
                                        format="dd/MM/yyyy"
                                        margin="normal"
                                        id="birthday"
                                        value={dateBirthday}
                                        onChange={(e) => setDateBirthday(e)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        placeholder="Дата рождения *"
                                        fullWidth
                                    />
                                </MuiPickersUtilsProvider>
                            </InputContainer>
                            <InputContainer isError={isError && (!phone || isError === 'phone') ? true : false}>
                                <PhoneInput
                                    country={'ru'}
                                    value={phone}
                                    onChange={phone => setPhone(phone)}
                                    autoFocus
                                    fullWidth
                                    variant="filled"
                                    id="phone"
                                    name="phone"
                                    placeholder="Телефон *"
                                    error={isError && (!phone || isError === 'phone') ? true : false}
                                />
                            </InputContainer>
                            <InputContainer>
                                <Input
                                    value={snils}
                                    onChange={(e) => setSnils(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    required
                                    id="snils"
                                    inputComponent={TextMaskCustomSnils}
                                    error={isError && (!snils || isError === 'snils') ? true : false}
                                />
                            </InputContainer>
                        </Grid>
                        <Grid item xs={12}>
                            <PersDataContainer>
                                {/* <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isPersData}
                                            onChange={(e) => setIsPersData(e.target.checked)}
                                            name="persDataChecker"
                                            color="primary"
                                        />
                                    }
                                    label={<> */}
                                {/* <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/agreement`}>согласие на обработку </Link> */}
                                        Используя приложение, вы принимаете условия
                                        <br />
                                <a href={`${process.env.REACT_APP_WEBSITE_NAME}/PersonalAgreement.pdf`} target="_blank"> пользовательского соглашения</a>
                                {/* </>}
                                /> */}
                            </PersDataContainer>
                        </Grid>
                    </Grid>

                    <InputContainer>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            onClick={onHandleRegister}
                            size='large'
                        >
                            Регистрация
                            {isLoading && <LoadingContainer><CircularProgress size={20} /></LoadingContainer>}
                        </Button>
                    </InputContainer>
                    <SuccessMessage>{successMessage}</SuccessMessage>
                    <ErrorMessage>{errorMessage}</ErrorMessage>
                    <InputContainer>
                        <LinksRow>
                            <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/auth`}>
                                <Button fullWidth>
                                    Авторизация
                                </Button>
                            </Link>
                            •
                            <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/forgot/1`}>
                                <Button
                                    fullWidth
                                    type="button"
                                >
                                    Забыли пароль
                                </Button>
                            </Link>
                        </LinksRow>
                    </InputContainer>
                </FormValidate>
            </>
        </MainAuthComponent>
    );
};

export default Register;
